import { get } from "lodash";
import { TableBody, TableRow, TableCell, Checkbox, cn } from 'twyne-new.ui';

import { ROW_SELECTION_COLUMN_WIDTH } from "@/components/tableResize/helper";

export default function DefaultTableBody({ rows = [], columns = [], loading = false, rowsSelected = [], setRowsSelected }) {
  return <TableBody>
    <TableBodyData
      rows={rows}
      columns={columns}
      loading={loading}
      rowsSelected={rowsSelected}
      setRowsSelected={setRowsSelected}
    />
  </TableBody>
}

function buildCellInfo({ row, rowIndex, column, cellValue }) {
  return {
    getInfo: () => row,
    getValue: () => cellValue,
    row: {
      id: row?.id ?? rowIndex,
      index: rowIndex,
      original: row,
    },
    column: {
      id: column.dataField,
      columnDef: {
        className: column.className,
      },
    },
  }
}

function TableBodyData({ rows, columns, loading, rowsSelected, setRowsSelected }) {
  if (rows?.length > 0) {
    return rows.map((row, rowIndex) => {
      const rowId = row?.id ?? rowIndex
      return <TableRow key={rowId}
        className={cn(rowIndex % 2 && 'twy-bg-base')}
        data-index={rowId}
      >
        {/* <RowCheckbox
          id={rowId}
          original={row}
          rowsSelected={rowsSelected}
          setRowsSelected={setRowsSelected}
        /> */}
        {columns.map(column => {
          const cellValue = get(row, column.dataField)
          const cellInfo = buildCellInfo({ row, rowIndex, column, cellValue })
          const content = column.formatter ? column.formatter(cellInfo) : cellValue

          return <TableCell key={`${rowId}-${column.id}`} className={column.className}>
            {content}
          </TableCell>
        })}
      </TableRow>
    })
  }

  if (!loading) {
    return <TableRow>
      <TableCell colSpan={100} className="text-center">
        No content to show.
      </TableCell>
    </TableRow>
  }

  return null
}

function RowCheckbox({ id, original, rowsSelected, setRowsSelected }) {
  const rowId = original?.id ?? id
  const isSelected = rowsSelected.includes(`${rowId}`)

  const handleSelectRow = (rowId, checkedValue) => {
    const checked = typeof checkedValue === 'boolean' ? checkedValue : !!checkedValue?.target?.checked

    setRowsSelected(prevRowsSelected => {
      const id = `${rowId}`
      if (checked) {
        if (prevRowsSelected.includes(id)) {
          return prevRowsSelected
        }
        return [...prevRowsSelected, id]
      }

      return prevRowsSelected.filter(selectedId => selectedId !== id)
    })
  }

  return <TableCell key={id} style={{ width: ROW_SELECTION_COLUMN_WIDTH }}>
    <Checkbox value={isSelected} onChange={checked => handleSelectRow(rowId, checked)} />
  </TableCell>
}
